import getRouterBasename from '@/lib/router';
import { toast } from 'sonner';

import { ChainlitAPI, ClientError } from '@chainlit/react-client';

const mode = import.meta.env.MODE;
let baseurl: string;

if (mode === 'production') {
  baseurl = 'https://askawatch.cbre.com';
  console.log('FetchIncidents: Running in PRODUCTION mode');
} else if (mode === 'staging') {
  baseurl = 'https://askawatch-test.cbre.com';
  console.log('FetchIncidents: Running in non prod mode');
} else {
  baseurl = 'http://localhost:8000';
  console.log('FetchIncidents: Running in DEVELOPMENT mode');
}

const devServer = baseurl + getRouterBasename();
const url = import.meta.env.DEV
  ? devServer
  : window.origin + getRouterBasename();
const serverUrl = new URL(url);

const httpEndpoint = serverUrl.toString();

const on401 = () => {
  if (window.location.pathname !== getRouterBasename() + '/login') {
    // The credentials aren't correct, remove the token and redirect to login
    window.location.href = getRouterBasename() + '/login';
  }
};

const onError = (error: ClientError) => {
  toast.error(error.toString());
};

export const apiClient = new ChainlitAPI(
  httpEndpoint,
  'webapp',
  on401,
  onError
);

export * from './incidentEmail'; // re-export sendIncidentEmail helper
export * from './fetchIncidents';
export * from './fetchApplications'; // new export
export * from './changevalidation'; // new export
export * from './userMetrics'; // new export
